import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from 'antd';
import InvestigationName from './InvestigationName';
import InvestigationMedicineType from './InvestigationMedicineType';
import InvestigationByStage from './InvestigationByStage';
import LineOfBusiness from './LineOfBusiness';
import InvestigationType from './InvestigationType';
import InvestigationArea from './InvestigationArea';

class Dimension extends Component {
    render() {
        const { fieldList, listCollection } = this.context;
        const { list = [], isEdit, visible, onClick, onDelete, onChange } = this.props;
        return (
            <div>
                {
                    list.map((item, index, array) => {
                        let Com, setting = {};
                        let listCollectionData = listCollection.find(el => el.responsibleFieldId == item.responsibleFieldId)
                        if (item.responsibleFieldId == 1) {
                            const { investigationAreaList, diseaseTypeList } = listCollectionData;
                            Com = InvestigationArea;
                            setting.areaList = investigationAreaList || [];
                            setting.rangeList = diseaseTypeList || [];
                        } else if (item.responsibleFieldId == 2) {
                            const { researchProductTypeList } = listCollectionData;
                            Com = InvestigationMedicineType;
                            setting.medicineTypeList = researchProductTypeList || [];
                        } else if (item.responsibleFieldId == 3) {
                            const { researchProductTypeList } = listCollection[1];
                            const { projectStagingList, projectStagingTypeList } = listCollectionData;
                            Com = InvestigationByStage;
                            setting.byStageList = projectStagingList || [];
                            setting.rangeList = projectStagingTypeList || [];
                            setting.medicineTypeList = researchProductTypeList || [];
                        } else if (item.responsibleFieldId == 4) {
                            const { businessLineList } = listCollectionData;
                            Com = LineOfBusiness;
                            setting.businessList = businessLineList || [];
                        } else if (item.responsibleFieldId == 5) {
                            const { projectCategoryList } = listCollectionData;
                            Com = InvestigationType;
                            setting.typeList = projectCategoryList || [];
                        } else if (item.responsibleFieldId == 6) {
                            const { investigationTypeList } = listCollectionData;
                            Com = InvestigationName;
                            setting.rangeList = investigationTypeList || [];
                        }
                        return (
                            <div key={item.id} style={{ position: 'relative', width: 455 }}>
                                <Com
                                    data={item}
                                    index={index}
                                    isEdit={isEdit}
                                    visible={visible}
                                    fieldList={fieldList}
                                    {...setting}
                                    onChange={onChange}
                                />
                                {
                                    array.length > 1 &&
                                    <Icon
                                        type="close-circle-o"
                                        style={{
                                            position: "absolute",
                                            right: "-30px",
                                            bottom: "0px",
                                            fontSize: "20px",
                                            color: '#F00',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => onDelete(index)}
                                    />
                                }
                            </div>
                        )
                    })
                }
                <div style={{marginTop: 10}}>
                    <Button type="primary" onClick={() => onClick('and')}>并且</Button>
                    <Button type="primary" style={{ marginLeft: 10 }} onClick={() => onClick('or')}>或者</Button>
                </div>
            </div>
        );
    }
}

Dimension.contextTypes = {
    fieldList: PropTypes.array,
    listCollection: PropTypes.array,
};

export default Dimension;


// WEBPACK FOOTER //
// ./src/components/user/fieldLeader/components/Dimension.js